export var get = function (keys) { return ({
    domain: 'kv',
    eventType: 'get',
    data: {
        keys: keys,
    },
}); };
export var set = function (keys) { return ({
    domain: 'kv',
    eventType: 'set',
    data: {
        items: keys,
    },
}); };
//# sourceMappingURL=kv.js.map